import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'absolutePath',
})
export class AbsolutePathPipe implements PipeTransform {
    transform(value: string): string {
        return value.startsWith('/') ? value : `/${value}`;
    }
}
